import React from 'react';
import { Link } from 'react-router-dom';
import { Network, MapPin, ArrowRight } from 'lucide-react';
import { LOCATIONS } from '../data/locations';

export const BrokerNetwork = () => (
  <section className="py-20 bg-blue-900" data-testid="broker-network">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
      <Network className="h-12 w-12 text-orange-400 mx-auto mb-5" />
      <h2 className="text-4xl font-bold text-white mb-4">A 500+ Broker Network Working For You</h2>
      <p className="text-lg text-blue-100 max-w-3xl mx-auto mb-10">
        Years of relationships with vetted, credit-checked brokers means more freight options, better rates,
        and repeat lanes you can count on. We leverage the entire network to keep your truck loaded.
      </p>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto">
        {[
          { n: '500+', l: 'Vetted Brokers' },
          { n: '48', l: 'States Covered' },
          { n: '100%', l: 'Credit Checked' },
          { n: '24/7', l: 'Load Sourcing' },
        ].map((s, i) => (
          <div key={i} className="bg-blue-800/50 rounded-2xl p-6 border border-blue-700">
            <div className="text-3xl font-bold text-orange-400">{s.n}</div>
            <div className="text-blue-200 text-sm mt-1">{s.l}</div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export const ServiceAreas = () => (
  <section className="py-20 bg-white" data-testid="service-areas">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-12">
        <h2 className="text-4xl font-bold text-gray-900 mb-4">Service Areas</h2>
        <p className="text-lg text-gray-600 max-w-3xl mx-auto">
          Based in Florida, dispatching across the Southeast and nationwide. Explore our local dispatch services.
        </p>
      </div>
      <div className="grid lg:grid-cols-2 gap-10 items-center">
        <div className="rounded-3xl overflow-hidden border-2 border-gray-100 shadow-sm" data-testid="service-area-map">
          <iframe
            title="Flow Fleet Solutions Service Area Map"
            src="https://www.google.com/maps?q=Florida&output=embed"
            className="w-full h-80 border-0"
            loading="lazy"
          />
        </div>
        <div className="grid sm:grid-cols-2 gap-4">
          {LOCATIONS.map((loc) => (
            <Link
              key={loc.slug}
              to={`/locations/${loc.slug}`}
              data-testid={`service-area-${loc.slug}`}
              className="group flex items-center justify-between gap-3 rounded-xl border-2 border-gray-100 hover:border-blue-200 hover:shadow-lg p-5 transition-all"
            >
              <div className="flex items-center gap-3">
                <MapPin className="h-5 w-5 text-orange-600" />
                <div>
                  <p className="font-bold text-gray-900">{loc.shortName}</p>
                  <p className="text-xs text-gray-500">{loc.region}</p>
                </div>
              </div>
              <ArrowRight className="h-4 w-4 text-blue-600 group-hover:translate-x-1 transition-transform" />
            </Link>
          ))}
        </div>
      </div>
    </div>
  </section>
);
